<template>
	<b-card>
		<div slot="header">
			<span><b>История документа</b></span>
		</div>
		<b-table :items="docs" :fields="columns" :busy="loading" striped hover show-empty>
			<template slot="id" slot-scope="data">
				{{ paginate(data.index, payload.page, payload.limit) }}
			</template>
			<template slot="actions" slot-scope="data">
				<b-badge @click="getHistoryDoc(data.item.id)" pill variant="dark" class="cursor-pointer"><span style="font-size: 12px" class="fa fa-eye"/></b-badge>
			</template>
		</b-table>
		<nav>
			<b-pagination :total-rows="total" :per-page="payload.limit" v-model="payload.page" align="center" aria-controls="table"/>
		</nav>

		<!--     View History Doc     -->
		<b-modal v-model="viewHistory" size="xl" hide-footer>
			<template #modal-header>
				<b>{{ $t('incomes.date') }} : </b> <span>{{ historyDocs.length > 0 ? historyDocs[0].regDate : '' }}</span>
				<b>{{ $t('incomes.name') }} : </b> <span>{{ historyDocs.length > 0 ? historyDocs[0].regNumber : '' }}</span>
				<b>{{ $t('Создано') }} : </b> <span>{{ historyDocs.length > 0 ? historyDocs[0].createdBy : '' }}</span>
				<span @click="viewHistory = false" class="fa fa-close mt-1 cursor-pointer"/>
			</template>
			<b-table :items="historyDocs" :fields="historyCols" striped hover show-empty>
				<template slot="id" slot-scope="data">
					{{ data.index+1 }}
				</template>
				<template slot="sum" slot-scope="data">
					{{ data.item.priceUzs*data.item.count }}
				</template>
			</b-table>
		</b-modal>
	</b-card>
</template>

<script>
import HistoryService from "./history.service";
import WhDocument from "../../services/wh-document.service";

export default {
	name: "docs-history",
	data() {
		return {
			payload: {
				page: 1,
				limit: 20
			},
			docs: [],
			total: null,
			historyDocs: [],
			columns: [
				{key: 'id', label: '№', 'class': 'text-center'},
				{key: 'regDate', label: this.$t('incomes.date'), 'class': 'text-center',},
				{key: 'regNumber', label: this.$t('incomes.name'), 'class': 'text-center', sortable: true},
				{key: 'contragentName', label: this.$t('incomes.counteragent'), sortable: true},
				{key: 'toDepartmentName', label: this.$t('incomes.department'), class: 'text-center'},
				{key: 'comment', label: this.$t('comment'), 'class': 'text-center'},
				{key: 'actions', label: this.$t('incomes.actions'), class: 'text-center'}
			],
			historyCols: [
				{key: 'id', label: '№', class: 'text-center'},
				{key: 'barcode', label: this.$t('goods.special-barcode'), class: 'text-center', sortable: true},
				{key: 'itemName', label: this.$t('goods.name'), sortable: true},
				{key: 'departmentName', label: this.$t('incomes.department'), class: 'text-center', sortable: true},
				{key: 'count', label: this.$t('sale.kol-vo'), class: 'text-center'},
				{key: 'remaining', label: 'Oстатка', class: 'text-center'},
				{key: 'priceUzs', label: this.$t('incomes.create.price'), class: 'text-center'},
				{key: 'sum', label: 'Сумма', class: 'text-center'}
			],
			loading: false,
			viewHistory: false
		}
	},
	watch: {
		'payload.page': {
			handler(e) {
				this.getDocs();
			}
		}
	},
	methods: {
		paginate(index, page_size, page_number) {
			--page_size;
			return (page_number * page_size) + index + 1;
		},
		getDocs() {
			WhDocument.searchManualKirim(this.payload).then(res => {
				this.docs = res.data.items
				this.total = res.data.total
			}).catch(e => {
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		getHistoryDoc(docId) {
			if (docId) {
				this.loading = true
				HistoryService.getHistoryDoc(docId).then(res => {
					this.loading = false
					this.viewHistory = true
					this.historyDocs = res.data
				}).catch(e => {
					this.loading = false
					this.$vs.notify({
						title: e.message,
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});
				})
			}
		}
	},
	created() {
		this.getDocs();
	}
}
</script>

<style scoped>

</style>
